import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "../reportSection.module.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Grid,
  Typography,
} from "@mui/material";
import { PoojaReportBySignInNameProps } from "../../../infrastructure/GlobalContextProvider";
import { ReportToRender } from "../../common/RenderSubReports";
import { useReactToPrint } from "react-to-print";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomDownIcon,
  CustomLeftIcon,
  CustomUpIcon,
} from "../../common/StyledComponents/StyledFields";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import { apiRequest } from "../../../infrastructure/backendService";
import VendorReportsTableData from "./VendorReportsTableData";
import apiPath from "../../../config/apiPaths.json";
import ErrorPopup from "../../common/ErrorPopup";
import toast, { Toaster } from "react-hot-toast";
import constants from "../../../config/constants.json";
import PrintTreasuryReports from "../treasury/PrintTreasuryReports";

const SystemReports = ({ subReports }: any) => {
  const [reportName, setReportName] = useState("");

  /* Data from Pooja Report Back to Main Report Section */
  const [dataFromChild, setDataFromChild] = useState(false);
  const [systemReportsData, setSystemReportsData] = useState<
    PoojaReportBySignInNameProps[]
  >([]);
  const [columnData, setColumnData] = useState({});
  const [subReportsAccordiansArray, setSubReportsAccordians] = useState(
    new Array(6).fill(false)
  );
  const [loading, setLoading] = useState(false);
  const [subReportsName, setSubReportsName] = useState("");
  const [systemReportsReqBody,setSystemReportsReqBody] = useState<any>()
  const [totalRecords,setTotalRecords] = useState<number>()
  const [pageSize, setPageSize] = useState<number>();
  const [printBtnLoading, setPrintBtnLoading] = useState(false);
  const [isPrintTriggered, setIsPrintTriggered] = useState(false);
  const [printData, setPrintData] = useState<any>(null);
  const [printActive, setPrintActive] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [printColumnData, setPrintColumnData] = useState({});

  function handleDataFromChild(data: any,{reqBody,reportName,totalRecords,pageSize}:any) {
    setDataFromChild(data);
    setReportName(reportName);    
    setSystemReportsReqBody(reqBody)
    if(reportName === 'Vendor Report'){
      setSubReportsName(reportName)
      setTotalRecords(totalRecords)
      setPageSize(pageSize)
    }
  }

  function handleGoingBackToMainReportsSection() {
    setDataFromChild(false);      
    setSystemReportsData([]);
    setColumnData([]);
    setPrintActive(true)
  }

  function getReportData(data: any) {
    let columnHeaders = data[0];
    let columns: any = {};
    for (let key of Object.keys(columnHeaders)) {
      columns[key] = key;
    }
    setSystemReportsData(data);
    setColumnData(columns);
  }
  const [expandedPanel, setExpandedPanel] = useState(null);

  const handleToggleChange = (index: any) => {
    setExpandedPanel(expandedPanel === index ? null : index);
    const accordianArray = [...subReportsAccordiansArray];
    accordianArray[index] = !accordianArray[index];
    setSubReportsAccordians(accordianArray);
    const reportObj = subReports.subMenus.find(
      (report: any, i: number) => i === index
    );
    setSubReportsName(reportObj.title);
  };

  const PrintStyles = `
 @page {
      size: tabloid;
      margin: 24px;
    }  
    /* Set layout to Landscape */
    body {
      width: ${subReportsName === 'Income Report' ? '40vw' : '100vw'};
      position: absolute;
      left:${subReportsName === 'Income Report' ? '30%' : ''};
      right:${subReportsName === 'Income Report' ? '30%' : ''};
    }
  @media print {
    .printable {
      display: block !important;
    }
  }
`;
  const PrintRef = useRef<any>(null);

  const handlePrint = useReactToPrint({
    content: () => PrintRef.current,
    documentTitle: "Print Document",
    suppressErrors: true,
    pageStyle: PrintStyles,
  });

  const handleExportAndPrint = async () => {
    await convertToPrint();
    setIsPrintTriggered(true);
  };
  
  useEffect(() => {
    if (isPrintTriggered && printData.length > 0 && printData.length < 15000) {
      handlePrint();      
      setIsPrintTriggered(false);
    }else if(printData && printData.length > 15000){
      // alert('Print Limit is exceeded, Please use Export to Excel')
      toast.custom(
        <ErrorPopup
          headerTitle="Attention"
          showMessage="Print Limit is exceeded, Please use Export to Excel"
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />,
        {
          duration: constants.TOAST_POPUP_DURATION,
        }
      );
      setPrintData([])
    }else{
      setPrintData([])
    }
  }, [printData, isPrintTriggered,handlePrint]);

  useEffect(()=>{
    setPrintData(printData)
  },[printData,systemReportsReqBody])

  const convertToPrint = useCallback(async ()=>{
    try{
      let endpoint: string = "";  
      switch (subReportsName) {
        case "Vendor Report":
          endpoint = `${apiPath.vendorReport}/VENDOR_REPORTS`
          break;
        default:
          break;
      }
      setPrintBtnLoading(true);
      if (endpoint) {
       const res =  await apiRequest({
          method: "GET",
          endpoint: endpoint,
          // body: JSON.stringify(reqBody),
        params: {
          pageNumber: 0,
          pageSize: 10000,
          },
          includeToken: true,
        })
         if(subReportsName === 'Vendor Report'){
          setPrintData(res.data.data);
         }
        let  columnHeaders = res.data.data[0]
        let columns: any = {};
        for (let key of Object.keys(columnHeaders)) {
          columns[key] = key;
        }
        setPrintColumnData(columns)  
        setPrintBtnLoading(false)
      } else {
        setPrintBtnLoading(false)
        console.error("Invalid subReportsName");
      }
    }catch(error) {
      setPrintBtnLoading(false)
      console.error('Error downloading Excel file:', error);
    }
  },[subReportsName, systemReportsReqBody])

  const ExportToExcel = async () => {
    try{
      // let reqBody: any = systemReportsReqBody;
      let endpoint: string = "";
  
      switch (subReportsName) {
        case "Vendor Report":
          endpoint = `${apiPath.vendorReport}/VENDOR_REPORTS/createSheet`;
          break;
        default:
          break;
      }
      setLoading(true);
      if (endpoint) {
       const response =  await apiRequest({
          method: "POST",
          endpoint: endpoint,
          // body: JSON.stringify(reqBody),
          params: {
            pageNumber: 0,
            pageSize: 10000,
            },
          includeToken: true,
          responseType: 'arraybuffer'
        })
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.download = `${subReportsName}.xlsx`;
        link.href = window.URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false)
      } else {
        setLoading(false)
        console.error("Invalid subReportsName");
      }
    }catch(error) {
      setLoading(false)
      console.error('Error downloading Excel file:', error);
    }
  };
  const displayReportName = ()=>{
    switch(subReportsName){
      case "Vendor Report":
        return "Vendor Report" 
      default:
        break;
    }
}
  return (
    <>
      {!dataFromChild ? (
        <div className={styles.poojareportsLayout}>
          <Typography className={styles.typoGraphyHeader}>
            System Reports
          </Typography>
          <Card className={styles.cardContainer}>
          <Grid container columnSpacing={"12px"} rowSpacing={"10px"}>
            {subReports &&
              subReports.subMenus.map((report: any, index: any) => (
                <Grid
                    item
                    xs={12}
                    md={expandedPanel === index ? 12 : 6}
                    key={index}
                  >
                  <Accordion
                    sx={{
                      border: subReportsAccordiansArray[index]
                        ? "1px solid #F05802"
                        : "1px solid #989898",
                      background: "#FFF9E4",
                      boxShadow: "none",
                      borderRadius: "8px",
                      ".MuiAccordionSummary-content.Mui-expanded": {
                        my: "12px"
                      },
                      ".MuiAccordionSummary-root.Mui-expanded": {
                        minHeight: "auto"
                      },
                    }}
                    expanded={expandedPanel === index}
                    // expanded={subReportsAccordiansArray[index]}
                    onChange={() => handleToggleChange(index)}
                  >
                    <AccordionSummary
                      aria-controls={`panel-content`}
                      id={`panel--header`}
                    >
                      <Box sx={{display: "flex", alignItems: "center"}}>
                        <Box className={styles.iconstyles}>
                          {expandedPanel === index ? (
                            <CustomUpIcon />
                          ) : (
                            <CustomDownIcon />
                          )}
                        </Box>
                        <Typography
                          className={"sub_heading"}
                          style={{fontWeight: "500", fontSize: "16px"}}
                        >
                          {report.title}
                        </Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{p: "0px 16px 16px 16px"}}>
                      {ReportToRender(
                        report.key,
                        handleDataFromChild,
                        getReportData
                      )}
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              ))}
            </Grid>
          </Card>
        </div>
      ) : (
        <Box ref={PrintRef}>
          {!printActive && <Toaster />}
          <Typography
            sx={{
              fontFamily: "Lato",
              fontSize: "20px",
              fontWeight: 500,
              color: "#882E14",
              display: "flex",
              gap: "10px",
            }}
          >
            <span
              style={{ margin: "4px 0" }}
              onClick={handleGoingBackToMainReportsSection}
              className="no_print"
            >
              <CustomLeftIcon />
            </span>
            <span>
                {displayReportName()}
             </span>
            <Box 
              sx={{
                display: "flex",
                gap: "16px",
                marginLeft: "auto",
                float: "right",
              }}
            >
              <CommonOutlinedButton onClick={handleExportAndPrint} className="no_print" 
              disabled={printBtnLoading || systemReportsData.length === 0}>
               <ButtonLoader
                  isBtnLoading={printBtnLoading}
                  btnText={"Print"}
                />
              </CommonOutlinedButton>
              <CommonButton
                style={{ whiteSpace: "nowrap" }}
                onClick={ExportToExcel}
                disabled={loading || systemReportsData.length === 0}
                className="no_print"
              >
                <ButtonLoader
                  isBtnLoading={loading}
                  btnText={"Export To Excel"}
                />
              </CommonButton>
            </Box>
          </Typography>
          <>
          <div className="no_print">
            <VendorReportsTableData
            tableHeaders={columnData}
            ReportData={systemReportsData}
            totalRecords={totalRecords}
            pageSize={pageSize}
            />
          </div>
             {printData && printData.length > 0 && <div className="printable" style={{display:'none'}}>
                  <PrintTreasuryReports
                      tableHeaders={printColumnData}
                      ReportData={printData}
                      reportName={subReportsName}    
                  />
              </div>}
            </>
        </Box>
      )}
    </>
  );
};

export default SystemReports;
